module.exports = __webpack_public_path__ + "img/3.7a9e46d6.png";